export class GlobalPhrases {
    static notifications = { default: 'Notifications', guid: 'a306d03c-7e53-486e-9329-811c2e7ca34c' };
    static language = { default: 'Language', guid: '79973b8f-d547-459f-a9fa-f19b88c031e1' };
}